<template>
  <div class="pt-3">
    <v-row no-gutters>
      <v-col cols="12" md="7" lg="7">
        <div class="pa-2">
          <v-card
            flat
            class="pa-3 mb-1 rounded-lg white--text"
            color="var(--g)"
            min-height="200px"
          >
            <h1>
              Hey ho<br />
              Super Admin!
            </h1>
          </v-card>
          <div class="py-3 temp_scroll" v-if="!loading && dataSet">
            <div class="temp_card">
              <v-row>
                <v-col cols="3">
                  <v-card flat class="pa-3 rounded-lg">
                    <v-card
                      flat
                      width="50px"
                      height="50px"
                      class="rounded-lg d-flex justify-center align-center mb-2"
                      color="#e5efec"
                    >
                      <v-icon color="var(--g)">mdi-face-man-shimmer</v-icon>
                    </v-card>
                    <b>Scholar</b>
                    <h2 class="color_default">{{ dataSet.scholar }}</h2>
                  </v-card>
                </v-col>
                <v-col cols="3">
                  <v-card flat class="pa-3 rounded-lg">
                    <v-card
                      flat
                      width="50px"
                      height="50px"
                      class="rounded-lg d-flex justify-center align-center mb-2"
                      color="#FFF3E0"
                    >
                      <v-icon color="orange"> mdi-human-male-board</v-icon>
                    </v-card>
                    <b>Teacher</b>
                    <h2 class="orange--text">{{ dataSet.teacher }}</h2>
                  </v-card>
                </v-col>
                <v-col cols="3">
                  <v-card flat class="pa-3 rounded-lg">
                    <v-card
                      flat
                      width="50px"
                      height="50px"
                      class="rounded-lg d-flex justify-center align-center mb-2"
                      color="#E8EAF6"
                    >
                      <facilitator-icon color="indigo" />
                    </v-card>
                    <b>Facilitator</b>
                    <h2 class="indigo--text">{{ dataSet.fasilitator }}</h2>
                  </v-card>
                </v-col>
                <v-col cols="3">
                  <v-card flat class="pa-3 rounded-lg">
                    <v-card
                      flat
                      width="50px"
                      height="50px"
                      class="rounded-lg d-flex justify-center align-center mb-2"
                      color="#F9FBE7"
                    >
                      <mentor-icon color="teal" />
                    </v-card>
                    <b>Mentor</b>
                    <h2 class="teal--text">{{ dataSet.mentor }}</h2>
                  </v-card>
                </v-col>
                <v-col cols="3">
                  <v-card flat class="pa-3 rounded-lg">
                    <v-card
                      flat
                      width="50px"
                      height="50px"
                      class="rounded-lg d-flex justify-center align-center mb-2"
                      color="#E1F5FE"
                    >
                      <v-icon color="blue">mdi-head-cog-outline</v-icon>
                    </v-card>
                    <b>Assessment</b>
                    <h2 class="blue--text">{{ dataSet.assessment }}</h2>
                  </v-card>
                </v-col>
                <v-col cols="3">
                  <v-card flat class="pa-3 rounded-lg">
                    <v-card
                      flat
                      width="50px"
                      height="50px"
                      class="rounded-lg d-flex justify-center align-center mb-2"
                      color="#FFFDE7"
                    >
                      <v-icon color="yellow">mdi-account-hard-hat</v-icon>
                    </v-card>
                    <b>UPCM</b>
                    <h2 class="yellow--text">{{ dataSet.upcm }}</h2>
                  </v-card>
                </v-col>
                <v-col cols="3">
                  <v-card flat class="pa-3 rounded-lg">
                    <v-card
                      flat
                      width="50px"
                      height="50px"
                      class="rounded-lg d-flex justify-center align-center mb-2"
                      color="#E0F7FA"
                    >
                      <v-icon color="cyan">mdi-account-hard-hat</v-icon>
                    </v-card>
                    <b>LD</b>
                    <h2 class="cyan--text">{{ dataSet.ld }}</h2>
                  </v-card>
                </v-col>
                <v-col cols="3">
                  <v-card flat class="pa-3 rounded-lg">
                    <v-card
                      flat
                      width="50px"
                      height="50px"
                      class="rounded-lg d-flex justify-center align-center mb-2"
                      color="#F3E5F5"
                    >
                      <v-icon color="purple">mdi-account-hard-hat</v-icon>
                    </v-card>
                    <b>ELSN</b>
                    <h2 class="purple--text">{{ dataSet.elsn }}</h2>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </div>
          <div class="py-3" v-if="loading">
            <v-row>
              <v-col cols="3" v-for="key in 8" :key="key">
                <v-skeleton-loader
                  height="142"
                  class="rounded-lg"
                  type="image"
                ></v-skeleton-loader>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-col>
      <v-col cols="12" md="5" lg="5">
        <div class="pa-2">
          <v-card class="pa-3 rounded-lg mb-2" flat min-height="200px">
            <v-row>
              <v-col cols="6"><h3>Announcement</h3></v-col>
              <v-col cols="6">
                <div class="d-flex justify-end">
                  <v-btn
                    color="blue"
                    text
                    @click="createData"
                    class="text-capitalize"
                    ><v-icon>mdi-plus</v-icon> Create New</v-btn
                  >
                </div>
              </v-col>
            </v-row>
            <div v-if="!loadAnnoun">
              <div v-if="announ.length" class="mt-3">
                <v-card
                  class="mb-3 cursor"
                  v-for="(item, i) in announ"
                  :key="i"
                >
                  <v-img
                    :src="item.foto ? item.foto : cover_ann"
                    class="white--text align-end"
                    gradient="to bottom, rgba(0,0,0,.2), rgba(0,0,0,.5)"
                    height="200px"
                    @click="viewAnouncement(item)"
                  >
                    <v-card-title v-text="item.title"></v-card-title>
                  </v-img>
                </v-card>
                <div class="d-flex justify-end">
                  <v-btn
                    text
                    color="blue"
                    to="/scholar-announcement"
                    class="pa-0 text-capitalize"
                    >View More <v-icon>mdi-chevron-right</v-icon></v-btn
                  >
                </div>
              </div>
              <div
                v-if="!announ.length"
                class="d-flex align-center justify-center mt-5"
              >
                No announcement yet
              </div>
            </div>
            <div v-if="loadAnnoun">
              <v-skeleton-loader
                v-for="key in 8"
                :key="key"
                height="142"
                class="rounded-lg mb-3"
                type="image"
              ></v-skeleton-loader>
            </div>
          </v-card>
          <!-- <v-card class="pa-3 rounded-lg" flat height="250px">
            <h3>Running Course</h3>
          </v-card> -->
        </div>
      </v-col>
    </v-row>
    <div class="pa-3">
      <create-announ
        :c_announ="c_announ"
        :type="d_type"
        @close="c_announ = false"
        @fetch="getAnounc"
        :inventory="inventory"
      />
      <view-anoun
        :v_announ="v_announ"
        :inventory="inventory"
        @close="v_announ = false"
      />
    </div>
  </div>
</template>

<script>
import CreateAnnoun from "../Announcement/createAnnoun.vue";
import ViewAnoun from "../Announcement/viewAnnoun.vue";
import FacilitatorIcon from "../sidebar/icon/facilitatorIcon.vue";
import mentorIcon from "../sidebar/icon/mentorIcon.vue";
import { mapState } from "vuex";
export default {
  components: { mentorIcon, FacilitatorIcon, CreateAnnoun, ViewAnoun },
  name: "adminOverview",
  data() {
    return {
      dataSet: null,
      loading: false,
      loadAnnoun: false,
      announ: [],
      c_announ: false,
      v_announ: false,
      inventory: null,
      d_type: "",
    };
  },
  computed: {
    ...mapState({
      cover_ann: (state) => state.banner_ann,
    }),
  },
  mounted() {
    this.fetchData();
    this.getAnounc();
  },
  methods: {
    fetchData() {
      this.loading = true;
      let data = {
        path: `overview/superadmin`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.dataSet = data;
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    getAnounc() {
      this.loadAnnoun = true;
      let data = {
        path: `announcement/data?page[size]=2&sort=-created_at`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.announ = data.data;
          this.loadAnnoun = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loadAnnoun = false;
        });
    },
    viewAnouncement(item) {
      this.inventory = item;
      this.v_announ = true;
    },
    createData() {
      let body = {
        title: "",
        description: "",
        image: null,
        year_tf: "all",
      };
      this.inventory = body;
      this.d_type = "create";
      this.c_announ = true;
    },
  },
};
</script>

<style scoped>
@media (max-width: 900px) {
  .temp_scroll {
    overflow: hidden;
    overflow-x: auto;
  }
  .temp_card {
    width: 700px;
  }
}
</style>
